class InfiniteScroll {
  constructor(rootSelector, originSelector, nextSelector) {
    if (!rootSelector || !originSelector || !nextSelector) {
      console.error('rootSelector, originSelector, and nextSelector are required');
      return;
    }

    this.root = document.querySelector(rootSelector);
    if (!this.root) {
      console.error(`Element with selector ${rootSelector} not found`);
      return;
    }

    this.originSelector = originSelector;
    this.nextSelector = nextSelector;

    this.initScrollObserver();
    this.initMutationObserver();
  }

  initScrollObserver() {

    const observedElement = this.getObservedElement();
    this.scrollObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const nextLink = this.root.querySelector(this.nextSelector);
          if (nextLink) {
            this.root.insertAdjacentElement('beforeend', this.createLoadingImage());
            nextLink.click();
          }

          this.scrollObserver.disconnect();
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    });

    observedElement && this.scrollObserver.observe(observedElement);
  }

  initMutationObserver() {
    this.mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        Array.from(mutation.addedNodes)
          .filter((node) => node.nodeType === Node.ELEMENT_NODE && node.matches(this.originSelector))
          .forEach(() => {
            const loadingElement = this.root.querySelector('.js-tmp-loading');

            if (loadingElement) {
              loadingElement.remove();
            }

            if (this.root.querySelector(this.nextSelector)) {
              this.scrollObserver.observe(this.getObservedElement());
            }
          });
      });
    });

    this.mutationObserver.observe(this.root, { childList: true, subtree: true });
  }

  getOrigin() {
    return this.root.querySelectorAll(this.originSelector);
  }

  getObservedElement() {
    const origins = this.getOrigin();
    return origins[origins.length - 1];
  }

  createLoadingImage() {
    const imageElement = document.createElement('img');
    imageElement.src = this.root.dataset.loadingImage;
    const divElement = document.createElement('div');
    divElement.classList.add('js-tmp-loading', 'text-center', 'p-3.5');
    divElement.appendChild(imageElement);
    return divElement;
  }
}

export default InfiniteScroll;
